import { render, staticRenderFns } from "./PaginatorV2.vue?vue&type=template&id=09fb8a6d"
import script from "./PaginatorV2.vue?vue&type=script&lang=js"
export * from "./PaginatorV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports